module.exports = __webpack_public_path__ + "static/media/SmartDash.4c4b025d.png";